import React, { FC } from 'react';
import Section from '../../../Components/Section/Section';
import Container from '../../../../../Common/Container/Container';
import MapWrapper from '../../../../../Common/MapWrapper';
import markerIcon from '../../../../../../assets/icons/point-green.svg';
import primaryMarkerIcon from '../../../../../../assets/icons/point-dark-blue.svg';
import { ILocation } from '../../../../../../interfaces/professional/Professional';
import MapLegend from '../../../Components/MapLegend/MapLegend';
import SectionTitle from '../../../../../Common/SectionTitle/SectionTitle';
import * as classes from './MapSection.module.scss';
import LocationsListItem from '../../../../../Common/LocationsListItem/LocationsListItem';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { GetInTouchMapSectionProps } from '../../../../../Sections/GetInTouch/MapSection/MapSection';

const MapSection: FC<GetInTouchMapSectionProps> = ({ primaryLocation, otherLocations, mobilityRadius, phoneNumber }) => {
  const { t } = useTranslation();
  const mapLegend = <MapLegend primaryLocationMarkerIcon={primaryMarkerIcon} otherLocationsMarkerIcon={markerIcon} />;

  const otherLocationMapper = (item: ILocation, index: number) => (
    <LocationsListItem key={index} title={item.name} description={item.placeDescription} />
  );

  return (
    <Section number={'03'} label={t('getInTouch.locationsSection.sectionTitle')}>
      <Container className={classes.wrapper}>
        <div className={'row'}>
          <div className='col-xl-5 col-lg-5 col-md-12 col-sm-12'>
            <div className={classes.infoWrapper}>
              <SectionTitle>{t('getInTouch.locationsSection.titleText')}</SectionTitle>
              <div className={classes.legendWrapper}>
                <LocationsListItem title={primaryLocation.name} description={primaryLocation.placeDescription} isPrimary={true} />
                {otherLocations.map(otherLocationMapper)}
              </div>
            </div>
          </div>
          <div className='col-xl-7 col-lg-7 col-md-12 col-sm-12'>
            <MapWrapper
              phoneNumber={phoneNumber}
              serviceId={'1'}
              mobilityRadius={mobilityRadius}
              otherLocations={otherLocations}
              primaryLocation={primaryLocation}
              otherLocationsMarkerIcon={markerIcon}
              primaryLocationMarkerIcon={primaryMarkerIcon}
              legendComponent={mapLegend}
            />
          </div>
        </div>
      </Container>
    </Section>
  );
};

export default MapSection;
